import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import * as $ from 'jquery';
import { VirtualTimeScheduler } from 'rxjs';

@Component({
	selector: 'pregled-sifrarnika',
	templateUrl: './pregled-sifrarnika.component.html',
	styleUrls: ['./pregled-sifrarnika.component.css']
})
export class PregledSifrarnikaComponent implements OnInit {
	@Output() onCancel = new EventEmitter<any>();
	loading : boolean = false; 
	currentView = 'main';
	novoPravnoLice : boolean = true; 
	odabranoPravnoLiceId : any = null;
	odabranoFizickoLiceId : any = null;
	prijave : any = [];
	odabraniVlasnikId : any = null;
	odabraniVlasnikNaziv : any = null;
	//old
	sortOption = 1; //dozvoljene vrijednosti su bodovi i vrijeme
	naziviSifrarnika = [{id : 'marka', naziv : 'Proizvođači vozila'}, {id : 'model', naziv : 'Tip vozila'} , {id : 'vrsta_vozila', naziv : 'Vrsta vozila'}
				, {id : 'tah_maker', naziv : 'Proizvođači tahografa'}, {id : 'etal_uredjaj', naziv : 'Uređaji za mjerenje brzine i pređenog puta'}
				, {id : 'etal_sat_meh', naziv : 'Uređaji za ispitivanje satnog mehanizma '}, {id : 'vrsta_pregleda', naziv : 'Vrste pregleda'}
				, {id : 'tehnicar', naziv : 'Tehničari'}, {id : 'svrha_dig_pregleda', naziv : 'Svrhe dig. kalibracije'}
				, {id : 'kartica_tehnicara', naziv : 'Kartice tehničara'}
				];
	
	daneList = [{id : '1', naziv : 'Da'}, {id : '0', naziv : 'Ne'}];

	nazivSifrarnika : any = ''; 
	nazivPretraga : any = null;
	pibPretraga : any = null;
	imePretraga : any = null;
	prezimePretraga : any = null;
	stavke : any = [];
	filterSifrarnik : any = null;
	
	constructor(public globalSrvc: GlobalService, public http : HttpClient) { }

	ngOnInit() {
		setTimeout(() => {
			/*var elems = document.querySelectorAll('.modal');
    		var instances = M.Modal.init(elems, {});*/
			M.updateTextFields();
		}, 1000);

		//this.ucitajStudProgram();	
	}

	sifrarnikSelected(event){
		this.ucitajStavke();
	}

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	ucitajStavke(){
		this.loading = true; 
		setTimeout(() => {
			this.http.get(this.globalSrvc.rootUrl + 'sifrarnici/list', {params: {naziv : this.nazivSifrarnika?this.nazivSifrarnika:''}})
			.subscribe(data => {
				this.stavke = data;
				//console.log(data);
				this.loading = false;
			},
			error => {
				this.loading = false;
			});	
		}, 1000);
	}
	
	msg : any = null; 

	savedata(stavka){
		//console.log('this.naziv', this.naziv);

		if (!stavka.naziv) {
			M.toast({html: 'Naziv ne smije biti prazan', displayLength : 3000});
			return;
		}

		let url = 'vlasnici/sifrarnik/izmijeni';
		/*if (this.id){
			url = 'vlasnici/pravno/izmijeni';
		}*/

		this.loading = true;
		let obj = {id : stavka.id, naziv : stavka.naziv, nazivSifrarnika : this.nazivSifrarnika, aktivan : stavka.aktivan};
		//console.log(obj);

		setTimeout(() => {				
		
			this.http.post(url, obj)
				.subscribe(data => {
					this.msg = data;
					//console.log(data);
					this.loading = false;
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 1000);
	}
}
